import { IOriginDestinationRequest } from "@common/models/OriginDestinationRequest";
import { FieldType, Model, Schema } from "@core/index";
import { IAirTransaction } from ".";
import { IOriginDestination } from "./OriginDestination";
import { IPaxTypeQuantity } from "./PaxTypeQuantity";

export enum CabinClass { Y, A, C }
export enum TripType { OneWay, RoundTrip, MultiCity }

export interface IAvailabilityRequest extends IAirTransaction {
    pnr?: string;
    originDestionations?: IOriginDestinationRequest[];
    currentOriginDestinations?: IOriginDestination[];
    tripType?: TripType;
    classOfService?: CabinClass;
    fareClassCode?: string;
    paxTypeQuantity?: IPaxTypeQuantity;
}

export class AvailabilityRequest extends Model implements IAvailabilityRequest {
    public static schema: Schema = new Schema("AvailabilityRequest");
    public id?: number;
    public pnr?: string;
    public originDestionations?: IOriginDestinationRequest[];
    public currentOriginDestinations?: IOriginDestination[];
    public tripType?: TripType;
    public classOfService?: CabinClass;
    public fareClassCode?: string;
    public paxTypeQuantity?: IPaxTypeQuantity;
    public jsessionId?: string;
    public transactionIdentifier?: string;

    constructor(values: IAvailabilityRequest) {
        super(AvailabilityRequest.schema);
        this.setValues(values);
    }
}

AvailabilityRequest.schema.addField("id").type(FieldType.Integer).primary();
AvailabilityRequest.schema.addField("transactionIdentifier").type(FieldType.String);
AvailabilityRequest.schema.addField("jsessionId").type(FieldType.String);
AvailabilityRequest.schema.addField("originDestionations").type(FieldType.List);
AvailabilityRequest.schema.addField("tripType").type(FieldType.Enum)
    .enum(TripType.OneWay, TripType.RoundTrip, TripType.MultiCity).default(TripType.RoundTrip);
AvailabilityRequest.schema.addField("classOfService").type(FieldType.Enum)
    .enum(CabinClass.Y, CabinClass.A, CabinClass.C).default(CabinClass.Y);
AvailabilityRequest.schema.addField("fareClassCode").type(FieldType.String);
AvailabilityRequest.schema.addField("paxTypeQuantity").type(FieldType.Relation);
